import { graphql } from "relay-runtime";

export const TODO_BOTTOM_SHEET_MAIN_SCREEN_QUERY = graphql`
  query TodoBottomSheetMainScreenQuery($todoId: ID!) {
    todo(id: $todoId) {
      id
      title
      isOrg
      canWrite

      ...TodoBottomSheetMainHeaderRight_todo
      ...TodoEditNewMainComponent_todo
      ...TodoBottomSheetTitle_todo
    }
  }
`;
